import { Action, createReducer, on } from '@ngrx/store';
import {
  ClearLabelsDataAction,
  GetLabelsSuccess,
  GetOndemandLangLabelsSuccess,
} from './labels.actions';

export interface LabelsState {
  labels?: LabelDict;
}

export interface LabelDict {
  [key: string]: LabelDict;
}

const initialState: LabelsState = {
  labels: {},
};

export function LabelsReducer(state: LabelsState | undefined, action: Action) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(
    GetLabelsSuccess,
    (state, { getLabelsResponse }) =>
      ({
        ...state,
        labels: { ...getLabelsResponse.state },
      } as LabelsState)
  ),
  on(
    GetOndemandLangLabelsSuccess,
    (state, { getLabelsResponse }) =>
      ({
        ...state,
        labels: { ...getLabelsResponse.state },
      } as LabelsState)
  ),
  on(ClearLabelsDataAction, (state) => initialState)
);
